import { Col } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { DropdownButton, Flex, FormItem, Input, Row } from 'ui';
import { defaultFontSize, fontOffset, maxFontResizeLength, maxFontSize } from '../../ticket-config';
import TicketFormDetailStatus from './ticket-form-detail-status';

const BoldLabel = styled.div`
    display: inline-block;
    font-weight: bold !important;
    font-size: ${p => p.fontSize}px !important;
    color: rgba(0, 0, 0, 0.85) !important;
`;

const FormLabel = styled(FormItem)`
  .ant-legacy-form-item-label{
    flex: 0 0 28% !important;
  }
  label {
    white-space: nowrap;
  }
`;

const FormLabelTitle = styled(FormLabel)`
  label {
    white-space: nowrap;
  }
  .ant-legacy-form-item-label {
    margin-right: 10px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
`;

const TicketTitle = styled.div`
  input {
    font-size: 20px;
  }
`;

const StyledDropdownButton = styled(DropdownButton)`
  float: right;
`;

const TicketToolbarHeader = ({
  ticket,
  form,
  intl,
  isDisabled,
  isNew,
  isSaving,
  dirty,
  hasError,
  isLoadingCategoryInfo,
  isCommentsLoading,
  isLoading,
  save,
  fullPage,
  cancelForm,
}) => {
  const titleValidator = form.getFieldDecorator('title', {
    initialValue: ticket.title,
    rules: [{ required: true, message: intl.formatMessage({ id: 'rules.TITLE' }) }],
  });

  return (
    <Row type='flex' gutter={16}>
      <Col flex='0 0 75%'>
        <FormLabelTitle
          label={
            <BoldLabel
              fontSize={(ticket.number?.length + 1) > maxFontResizeLength ?
                defaultFontSize :
                maxFontSize - ((ticket.number?.length + 1) * fontOffset)
              }
            >
              {!isNew ? ticket.number : intl.formatMessage({ id: 'tickets.NEW_TICKET' })}
            </BoldLabel>
          }
          labelCol={{ span: 2 }}
        >
          <TicketTitle>
            {titleValidator(<Input disabled={isDisabled} />)}
          </TicketTitle>
        </FormLabelTitle>
      </Col>
      <Col flex='0 0 25%'>
        <Flex jcsb ffrn aic>
          <TicketFormDetailStatus
            isNew={isNew}
            isSaving={isSaving}
            isDirty={dirty}
            hasError={hasError}
          />
          <StyledDropdownButton
            colortheme='theme'
            isLoading={isSaving}
            text={intl.formatMessage({ id: 'ticket.BUTTON_SAVE' })}
            disabled={isLoadingCategoryInfo || isCommentsLoading || isLoading}
            // Needs to be () => save() because otherwise the click event is set as callback
            onClick={() => save()}
            subItems={[
              {
                text: fullPage
                  ? intl.formatMessage({ id: 'ticket.BUTTON_REVERT' }).toUpperCase()
                  : intl.formatMessage({ id: 'ticket.BUTTON_CANCEL' }).toUpperCase(),
                onClick: () => cancelForm(),
                disabled: isNew,
              },
            ]}
            dataTestId='btn-save-ticket'
          />
        </Flex>
      </Col>
    </Row>);
};


TicketToolbarHeader.propTypes = {
  form: PropTypes.object,
  intl: PropTypes.object,
  ticket: PropTypes.object,
  isNew: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isSaving: PropTypes.bool,
  isCommentsLoading: PropTypes.bool,
  isLoading: PropTypes.bool,
  fullPage: PropTypes.bool,
  dirty: PropTypes.bool,
  isLoadingCategoryInfo: PropTypes.bool,
  save: PropTypes.func,
  hasError: PropTypes.bool,
  cancelForm: PropTypes.func,
};

export default injectIntl(TicketToolbarHeader);
